import styled from '@emotion/styled';

export const Container = styled.div<{ isActive?: boolean }>`
  display: block;
  width: 46px;
  height: 46px;
  border-radius: 100%;
  border: 0;
  transition: all 0.3s ease;
  text-align: center;
  cursor: pointer;
  background: ${({ isActive }) => (isActive ? '#28C6AB' : '#1f1f1f')};

  span {
    color: ${({ isActive }) => (isActive ? '#28C6AB' : '#777777')};
    font-size: 12px;
  }
`;

export const IconWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 6px;
`;
